import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { adminEndpoints } from "@/features/admin/api/endpoints";
import type { ApiClientDto, ApiClientFilter } from "@/features/admin/api/dto";

/**
 * Liste paginée des clients API partenaires (`POST /ApiClients/all` —
 * endpoint PROPRE AU GATEWAY, sans préfixe `/gw/`, §6.1).
 * Rôles : flashpay-superadmin, flashpay-admin.
 */
export const useApiClients = (
  params: ListRequest<ApiClientFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.ADMIN_API_CLIENTS_LIST(params),
    queryFn: () =>
      mutateData({
        url: adminEndpoints.apiClients.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<ApiClientDto>>,
    enabled,
  });
